// src/ResolveIssueModal.js
import React, { useState } from 'react';
import './ResolveIssueModal.css';

function ResolveIssueModal({ issue, onClose, onResolve }) {
  const [comment, setComment] = useState('');

  const handleResolve = () => {
    if (comment.trim() === '') {
      alert('Please enter a resolution comment.');
      return;
    }
    onResolve(issue.id, comment);
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Resolve Issue</h3>
        <p>
          <strong>Theater {issue.theaterNumber}, Seat {issue.seatNumber}</strong>
        </p>
        <p>{issue.comment}</p>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Enter resolution comment"
          required
        ></textarea>
        <div className="modal-actions">
          <button onClick={handleResolve}>Resolve</button>
          <button onClick={onClose} className="cancel-button">Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default ResolveIssueModal;
